/* global wp */

const { i18n: { __ } } = wp; // eslint-disable-line @typescript-eslint/naming-convention

export default {
  aoy: {
    aoy: {
      format: 'leaderboard',
      banner: 'aoy_banner',
      slot: 'basstrakk_box',
      title: __('Progressive Bassmaster Angler of the Year', 'bassmaster-theme'),
    },
    roy: {
      format: 'leaderboard',
      banner: 'aoy_banner',
      slot: 'basstrakk_box',
      title: __('Dakota Lithium Elite Series Rookie of the Year', 'bassmaster-theme'),
    },
    central: {
      format: 'leaderboard',
      banner: 'aoy_banner',
      slot: 'basstrakk_box',
      title: __('Central Opens', 'bassmaster-theme'),
    },
    opens: {
      format: 'leaderboard',
      banner: 'aoy_banner',
      slot: 'basstrakk_box',
      title: __('Tackle Warehouse Bassmaster Elite Qualifiers', 'bassmaster-theme'),
    },
    eqs: {
      format: 'leaderboard',
      banner: 'aoy_banner',
      slot: 'basstrakk_box',
      title: __('Nitro Boats Bassmaster Elite Qualifiers', 'bassmaster-theme'),
    },
    northern: {
      format: 'leaderboard',
      banner: 'aoy_banner',
      slot: 'basstrakk_box',
      title: __('Northern Opens', 'bassmaster-theme'),
    },
    southern: {
      format: 'leaderboard',
      banner: 'aoy_banner',
      slot: 'basstrakk_box',
      title: __('Southern Opens', 'bassmaster-theme'),
    },
    eastern: {
      format: 'leaderboard',
      banner: 'aoy_banner',
      slot: 'basstrakk_box',
      title: __('Eastern Opens', 'bassmaster-theme'),
    },
    western: {
      format: 'leaderboard',
      banner: 'aoy_banner',
      slot: 'basstrakk_box',
      title: __('Western Opens', 'bassmaster-theme'),
    },
    d1: {
      format: 'leaderboard',
      banner: 'aoy_banner',
      slot: 'basstrakk_box',
      title: __('St. Croix Bassmaster Opens presented by SEVIIN - Div. 1', 'bassmaster-theme'),
    },
    d2: {
      format: 'leaderboard',
      banner: 'aoy_banner',
      slot: 'basstrakk_box',
      title: __('St. Croix Bassmaster Opens presented by SEVIIN - Div. 2', 'bassmaster-theme'),
    },
    d3: {
      format: 'leaderboard',
      banner: 'aoy_banner',
      slot: 'basstrakk_box',
      title: __('St. Croix Bassmaster Opens presented by SEVIIN - Div. 3', 'bassmaster-theme'),
    },
    kayak: {
      format: 'leaderboard',
      banner: 'aoy_banner',
      slot: 'basstrakk_box',
      title: __('Dakota Lithium Bassmaster Kayak Series Angler of the Year', 'bassmaster-theme'),
    },
  },
  basstrakk: {
    basstrakk: {
      format: 'basstrakk',
      banner: 'basstrakk_banner',
      slot: 'basstrakk_box',
    },
    coanglers: {
      format: 'basstrakk',
      banner: 'basstrakk_banner',
      slot: 'basstrakk_box',
    },
    bigbass: {
      format: 'basstrakk',
      banner: 'bigbass_banner',
      slot: 'basstrakk_box',
    },
    catches: {
      format: 'basstrakk',
      banner: 'catches_banner',
      slot: 'basstrakk_box',
    },
    aoy: {
      format: 'basstrakk',
      banner: 'aoy_banner',
      slot: 'basstrakk_box',
    },
  },
};
